import type { AiModelsSettings, AppSettingsV1 } from "./settings-types.js";
import { APP_SETTINGS_STORAGE_KEY } from "./settings-types.js";

export const defaultAiModels = (): AiModelsSettings => ({
  reasoningModel: "deepseek/deepseek-chat",
  visionModel: "gpt-4o",
  visionOpenAIBaseUrl: "https://api.openai.com/v1",
});

function defaultSettings(): AppSettingsV1 {
  return {
    version: 1,
    aiModels: defaultAiModels(),
  };
}

export function loadAppSettings(): AppSettingsV1 {
  try {
    const raw = localStorage.getItem(APP_SETTINGS_STORAGE_KEY);
    if (!raw) return defaultSettings();
    const parsed = JSON.parse(raw) as Partial<AppSettingsV1>;
    if (parsed?.version !== 1 || !parsed.aiModels || typeof parsed.aiModels !== "object") {
      return defaultSettings();
    }
    const base = defaultSettings();
    return {
      version: 1,
      aiModels: {
        ...base.aiModels,
        ...parsed.aiModels,
      },
    };
  } catch {
    return defaultSettings();
  }
}

export function saveAppSettings(next: AppSettingsV1): void {
  try {
    localStorage.setItem(APP_SETTINGS_STORAGE_KEY, JSON.stringify(next));
  } catch {
    /* quota / private mode */
  }
}
